import styles from "./index.module.css";
import React, { useState, useEffect } from "react";

import Button, { ButtonPurpose } from "shared/Button";
import TextInput from "shared/@forms/TextInput";
import EmailInput from "shared/@forms/EmailInput";
import PhoneInput from "shared/@forms/PhoneInput";
import { Form } from "shared/@forms/Form";

// Editable fields:
//  - First name
//  - Last name
//  - Phone number
//  - Email address

export default function ContactEdit({ data, disabled, onSubmit, onCancel }) {
  const [editData, setEditData] = useState(data);

  useEffect(() => {
    setEditData(data);
  }, [data]);

  return (
    <div className={styles.container}>
      <Form
        onSubmit={(e) => {
          onSubmit(editData);
        }}
      >
        <div className={styles.splitGroup}>
          <div className={styles.inputGroup}>
            <label htmlFor="firstName">First Name</label>
            <TextInput
              id="firstName"
              required={true}
              disabled={disabled}
              value={editData.firstName}
              onChange={(e) => {
                setEditData({
                  ...editData,
                  firstName: e.target.value,
                });
              }}
            />
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="lastName">Last Name</label>
            <TextInput
              id="lastName"
              required={true}
              disabled={disabled}
              value={editData.lastName}
              onChange={(e) => {
                setEditData({
                  ...editData,
                  lastName: e.target.value,
                });
              }}
            />
          </div>
        </div>

        <div className={styles.splitGroup}>
          <div className={styles.inputGroup}>
            <label htmlFor="phone">Phone</label>
            <PhoneInput
              id="phone"
              required={true}
              disabled={disabled}
              value={editData.phone}
              onChange={(e) => {
                setEditData({
                  ...editData,
                  phone: e.target.value,
                });
              }}
            />
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="firstName">Email</label>
            <EmailInput
              id="firstName"
              required={true}
              disabled={disabled}
              value={editData.email}
              onChange={(e) => {
                setEditData({
                  ...editData,
                  email: e.target.value,
                });
              }}
            />
          </div>
        </div>

        <div className={styles.actions}>
          <Button purpose={ButtonPurpose.save} disabled={disabled}>
            {editData.contactPK == null ? "Add Contact" : "Save Contact"}
          </Button>

          <Button
            disabled={disabled}
            onClick={(e) => {
              e.preventDefault();
              onCancel();
            }}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </div>
  );
}
